import HttpClient from "../../../services/http-client";
import { IDashboardResponse, IDashboardFilter } from "../../../../model/scp/dashboard/dashboard-response";

const defaultPath = 'Dashboard';

const getOverview = async (filter?: IDashboardFilter): Promise<IDashboardResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Overview`,
        params: filter
    }).then((response) => response.data);
};

const DashboardAppService = {
    getOverview
};

export default DashboardAppService;
